import { defineStore } from "pinia";

const MSG_CHECKOUT_FAILED = "could not start subscription checkout";
const MSG_CURRENT_LOAD_FAILED = "could not load the fan's current subscription for this publication";

const MSG_NO_CHECKOUT_URL = "subscription checkout returned no session url";

export const useSubscriptionCheckoutStore = defineStore("subscription-checkout-store", {
  state: () => ({
    isStartingCheckout: false,
    startingPlanId: 0,
    currentPlanIdByPublication: {},
    loadedPublicationIds: [],
  }),
  getters: {
    currentPlanIdForPublication: state => {
      return publicationId => Number(state.currentPlanIdByPublication[publicationId]) || 0;
    },
  },
  actions: {
    loadCurrentSubscription(publicationId) {
      if (!publicationId || this.loadedPublicationIds.includes(publicationId)) {
        return;
      }
      this.loadedPublicationIds.push(publicationId);

      this.apiGet(
        `/subscription/publication/${publicationId}/current`,
        {},
        data => {
          this.currentPlanIdByPublication[publicationId] = Number(data?.subscription?.subscription_plan_id) || 0;
        },
        error => {
          // eslint-disable-next-line no-console
          console.error(MSG_CURRENT_LOAD_FAILED, {
            publicationId,
            status: error?.response?.status,
            body: error?.response?.data,
          });
        },
      );
    },
    startCheckout(subscriptionPlanId, publicationId, successUrl, cancelUrl) {
      if (this.isStartingCheckout) {
        return;
      }
      this.isStartingCheckout = true;
      this.startingPlanId = subscriptionPlanId;

      this.apiPost(
        `/subscriber/plan/${subscriptionPlanId}/subscribe`,
        {
          publication_id: publicationId,
          success_url: successUrl,
          cancel_url: cancelUrl,
        },
        data => {
          this.isStartingCheckout = false;
          this.startingPlanId = 0;
          if (data?.switched_to_free_plan) {
            window.location.reload();
            return;
          }
          const checkoutUrl = data?.checkout_session?.url;
          if (!checkoutUrl) {
            // eslint-disable-next-line no-console
            console.error(MSG_NO_CHECKOUT_URL, { subscriptionPlanId, publicationId, data });
            return;
          }
          window.location.href = checkoutUrl;
        },
        error => {
          this.isStartingCheckout = false;
          this.startingPlanId = 0;
          // eslint-disable-next-line no-console
          console.error(MSG_CHECKOUT_FAILED, {
            subscriptionPlanId,
            publicationId,
            status: error?.response?.status,
            body: error?.response?.data,
          });
        },
      );
    },
  },
});

export default useSubscriptionCheckoutStore;
